
import script from '/home/circleci/app/packages/layout-braze-component/src/entries/index';
import { handleCSRError } from '@fiverr-private/layout_lib/CSRTemplate';

try {
    const props = window.initialData['Braze'];
    script(props);
}
catch(error) {
    handleCSRError(error, "Braze", "Braze")
}
